module.exports = __webpack_public_path__ + "media/images/flags/16/Mauritius-c66318e879a6765df867723aa3d7aa62.png";